import TextInputWithInlineLabel from '../TextInputWithInlineLabel.jsx';
import { addDays } from 'date-fns';
import TextInput from '~/components/TextInput';
import DateInput from '~/components/DateInput';

const ExpiresDateInput = ({ value, onChange, defaultExpirationDays }) => {
    const hasExpiration = !!value;

    return (
        <div className="pl-6 flex-1">
            <div className="py-3">
                <label className="flex items-center gap-x-4">
                    <input
                        type="radio"
                        checked={hasExpiration}
                        onChange={ev =>
                            ev.target.checked &&
                            onChange(
                                addDays(
                                    new Date(),
                                    defaultExpirationDays || 30,
                                ),
                            )
                        }
                    />
                    Expires on
                </label>
                {hasExpiration && (
                    <DateInput value={value} onChange={onChange} />
                )}
            </div>
            <label className="py-3 border-t flex items-center gap-x-4">
                <input
                    type="radio"
                    checked={!hasExpiration}
                    onChange={ev => ev.target.checked && onChange('')}
                />
                No expiration
            </label>
        </div>
    );
};

export default ExpiresDateInput;
